// import InputDateNative from "./InputDateNative"
import InputDatePolyfill from "./InputDatePolyfill"
import isNativeInputDateSupported from "./isNativeInputDateSupported"

export const InputDate = props => {
  return isNativeInputDateSupported() ? (
    <InputDatePolyfill {...props} />
  ) : (
    <InputDatePolyfill {...props} />
  )
}

export default InputDate
